export const enum WsAction {
    Ping = 'ping',
    Pong = 'pong',

    UnreadCounterRequest = 'subscribe_unread_counter_update',
    UnreadCounterReply = 'subscribed_unread_counter_update',
    UnreadCounterUpdate = 'unread_counter_update',

    State = 'state',
    Auth = 'auth',
    AuthReply = 'auth_replay',
    HistoryRequest = 'history_request',
    HistoryReply = 'history_replay',
    ChangeAgent = 'change_agent',
    AppealClosed = 'appeal_closed',
    Typing = 'typing',
    SendMessage = 'send_message',
    ReceiveMessage = 'receive_message',
    MessageReceived = 'message_received',
    MessageRead = 'message_read',
    ReceiveAgent = 'receive_agent',
    CsiRequest = 'csi_request',
    CsiReceived = 'csi_request_received',
    CsiReply = 'csi_replay',
    SearchRequest = 'search_request',
    SearchReply = 'search_reply',
    SearchByDateRequest = 'search_by_date_request',
    SearchByDateReply = 'search_by_date_reply',
    MarkFavorite = 'mark_favorite',
    UnmarkFavorite = 'unmark_favorite',
    SharingStarted = 'sharing_stared',
    SharingStopped = 'sharing_stopped',
    DeeplinkRequest = 'deeplinks_settings_request',
    DeeplinkReply = 'deeplinks_settings_reply',
    HistoryDumpRequest = 'history_dump_request',
    HistoryDumpReply = 'history_dump_reply',
    TotalMessageCountRequest = 'total_message_count_request',
    TotalMessageCountReply = 'total_message_count_reply',

    GameScoreRequest = 'game_score_request',
    GameScoreReply = 'game_score_reply',
    GameScoreUpdateRequest = 'game_score_update_request',
    GameScoreUpdateReply = 'game_score_update_reply',
    GameScoreUpdateEncryptedRequest = 'game_score_update_encrypted_request',
    GameScoreUpdateEncryptedReply = 'game_score_update_encrypted_reply',

    QuickActionsMenuRequest = 'quick_actions_menu_request',
    QuickActionsMenuReply = 'quick_actions_menu_reply',

    DialogAggregateRequest = 'dialog_aggregate_request',
    DialogAggregateReply = 'dialog_aggregate_reply',
    DialogAggregateImageRequest = 'dialog_aggregate_image_request',
    DialogAggregateImageReply = 'dialog_aggregate_image_reply',
    DialogAggregateDocumentRequest = 'dialog_aggregate_document_request',
    DialogAggregateDocumentReply = 'dialog_aggregate_document_reply',
    DialogAggregateLinkRequest = 'dialog_aggregate_link_request',
    DialogAggregateLinkReply = 'dialog_aggregate_link_reply',
    DialogAggregateVoiceMessagesRequest = 'dialog_aggregate_voice_messages_request',
    DialogAggregateVoiceMessagesReply = 'dialog_aggregate_voice_messages_reply',

    PredictivesRequest = 'predictives_request',
    PredictivesReply = 'predictives_reply',
    AddReactionRequest = 'add_reaction_request',
    AddReactionReply = 'add_reaction_reply',
    RemoveReactionRequest = 'remove_reaction_request',
    RemoveReactionReply = 'remove_reaction_reply',
    MessageRequest = 'message_request',
    MessageReply = 'message_reply',
    AsrResult = 'asr_result',

    OUT_CREATE_SESSION = 'sharing_create_client_session',
    IN_SESSION_CREATED = 'sharing_client_session',

    OUT_SEND_OFFER_SDP = 'sharing_receive_video_from',
    OUT_SEND_ICE_CANDIDATE = 'sharing_on_ice_candidate',
    IN_ANSWER_SDP = 'sharing_receive_video_answer',
    IN_ICE_CANDIDATE = 'sharing_ice_candidate',

    OUT_STOP_SCREENSHARING = 'sharing_leave_room',
    OUT_ACCEPT_REQUEST = 'screensharing_accept_request',
    IN_REQUEST = 'screensharing_request',
    IN_STOP = 'screensharing_stop',
    IN_OPERATOR_VIEWS_SHARE = 'sharing_new_participant_arrived',

    UNREAD_REACTIONS_REQUEST = 'unread_reactions_request',
    UNREAD_REACTIONS_REPLY = 'unread_reactions_reply',
    REACTION_READ = 'reaction_read',
    REACTION_READ_REPLY = 'read_reaction_reply',
    REACTION_ADDED = 'reaction_added',
    REACTION_REMOVED = 'reaction_removed',
}

export const alertableActions = [
    WsAction.HistoryRequest,
    WsAction.SearchRequest,
    WsAction.SearchByDateRequest,
    WsAction.MarkFavorite,
    WsAction.UnmarkFavorite,
    WsAction.HistoryDumpRequest,
    WsAction.GameScoreRequest,
    WsAction.GameScoreUpdateEncryptedRequest,
    WsAction.DialogAggregateImageRequest,
    WsAction.DialogAggregateDocumentRequest,
    WsAction.DialogAggregateLinkRequest,
    WsAction.DialogAggregateVoiceMessagesRequest,
    WsAction.AddReactionRequest,
    WsAction.RemoveReactionRequest,
    WsAction.MessageRequest,
    WsAction.REACTION_READ,
];

export const closableActions = [WsAction.Ping, WsAction.Auth];
